<script lang="ts" setup>
import { capIsNativePlatform } from '@exchange/libs/utils/capacitor/src';
import handleNativeGoTo from '@exchange/libs/utils/capacitor/src/lib/handle-native-go-to';

const contactSupport = () => {
  const supportUrl = 'https://support.onetrading.com/requests/new';

  if (capIsNativePlatform()) {
    handleNativeGoTo(supportUrl);
  } else {
    window.location.href = supportUrl;
  }
};
</script>

<template>
  <div class="blocked-overlay">
    <p class="blocked-overlay__message">
      {{ $t('modules.transactions.userBlocked.title') }}
    </p>
    <x-button
      class="blocked-overlay__button"
      variant="primary"
      @click="contactSupport"
    >
      <i18n-t
        keypath="modules.transactions.userBlocked.text"
        scope="global"
      >
        <template #linkText>
          {{ $t('modules.transactions.userBlocked.linkText') }}
        </template>
      </i18n-t>
    </x-button>
  </div>
</template>

<style lang="scss">
.blocked-overlay {
  position: absolute;
  z-index: var(--blocked-overlay-z-index);
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgb(var(--v-theme-overlay-2));
  opacity: 1;
  transition: opacity 200ms ease-out;

  &__message {
    padding: 0 10px;
    margin-bottom: 16px;
    color: rgb(var(--v-theme-text-primary));
    font-size: var(--font-size-md);
    text-align: center;
  }

  &__button {
    width: calc(70% - 20px);
  }
}
</style>
